const translations = require('./translations.json');

function toLocaleLanguage(textName, currentLang) {
    return translations[textName]?.[currentLang] ?? "No translation found";
}

module.exports = {toLocaleLanguage};
